/*
 * LW (2026-10-06): tell variant-aware apps (Globo Product Options' per-variant pack
 * descriptions) when the variant changes. Horizon updates the product form's hidden
 * input[name="id"] in place without firing an event; apps written for older themes
 * wait for a `change` on that input. After any variant-picker change we watch the
 * input for up to 3 s and fire one bubbling `change` when its value moves.
 * Horizon's own variant-picker listens on itself, not on this input, so no loop.
 */
(() => {
  const SEL = 'product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]';
  document.addEventListener('change', (e) => {
    if (!(e.target instanceof Element) || !e.target.closest('variant-picker')) return;
    const inputs = [...document.querySelectorAll(SEL)];
    if (!inputs.length) return;
    const before = inputs.map((i) => i.value);
    const t0 = performance.now();
    const tick = () => {
      let moved = false;
      inputs.forEach((i, n) => {
        if (i.isConnected && i.value && i.value !== before[n]) {
          before[n] = i.value;
          moved = true;
          i.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      if (!moved && performance.now() - t0 < 3000) setTimeout(tick, 60);
    };
    setTimeout(tick, 0);
  });
})();
